export enum EnumFeatureFlipping {
  SCA = 'SCA',
  MANAGEMENT_TOOLS_ONBOARDING = 'MANAGEMENT_TOOLS_ONBOARDING',
}
